import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from "./style.module.scss"

const CRBtn = ({ value, handleChange, text1, text2 }) => {
    const { t, i18n } = useTranslation()
    let direction = i18n.dir()
    return (
        <>
            <div dir={direction} className={`${styles['crbtn-context']} ${value === true ? styles.enable : ''}`} onClick={(e) => handleChange(e, !value)}>
                <span className={`${value ? styles.selected : ''}`}>{text1}</span>
                <span className={`${!value ? styles.selected : ''}`} >{text2}</span>
            </div>
        </>

    )
}

export default CRBtn
